import { render, staticRenderFns } from "./BannerImages.vue?vue&type=template&id=2412ef1c&scoped=true"
import script from "./BannerImages.vue?vue&type=script&lang=js"
export * from "./BannerImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412ef1c",
  null
  
)

export default component.exports